module.exports = __webpack_public_path__ + "img/AI_07.ac407807.png";